"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8664],{

/***/ 73480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87536);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57333);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96861);
/* harmony import */ var _text_field__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80367);
/* harmony import */ var _typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9769);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);
/* eslint-disable react/no-unused-prop-types */










function TextFieldPhone(_ref) {
  var control = _ref.control,
      label = _ref.label,
      name = _ref.name,
      error = _ref.error,
      initialValue = _ref.initialValue,
      placeholder = _ref.placeholder,
      largeLabelSize = _ref.largeLabelSize,
      disabled = _ref.disabled,
      rules = _ref.rules;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_text_field__WEBPACK_IMPORTED_MODULE_4__/* .TextFieldWrapper */ .DO, {
    children: [label && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_text_field__WEBPACK_IMPORTED_MODULE_4__/* .TextFieldLabel */ .pU, {
      className: "outlined-input-label",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("label", {
        htmlFor: name,
        children: largeLabelSize ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_typography__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
          fontWeight: "medium",
          children: label
        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          type: "mode2",
          fw: "light",
          children: label
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_text_field__WEBPACK_IMPORTED_MODULE_4__/* .TextFieldInput */ .Nl, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_7__/* .Controller */ .Qr, {
        defaultValue: initialValue,
        control: control,
        rules: rules,
        name: name,
        render: numberController(error, placeholder, disabled)
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_text_field__WEBPACK_IMPORTED_MODULE_4__/* .TextFieldError */ .ns, {
      children: (error === null || error === void 0 ? void 0 : error.message) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        type: "mode2",
        fw: "medium",
        children: error.message
      })
    })]
  });
}

function numberController(error, placeholder, disabled) {
  return function renderNumberController(_ref2) {
    var _ref2$field = _ref2.field,
        onChange = _ref2$field.onChange,
        fieldName = _ref2$field.name,
        fieldValue = _ref2$field.value,
        onBlur = _ref2$field.onBlur;

    function handleValueChange(values) {
      var value = values.value;
      onChange(value);
    }

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : 'Phone Number',
      format: "+1 (###) ###-####",
      mask: "_",
      name: fieldName,
      value: fieldValue,
      onValueChange: handleValueChange,
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()({
        invalid: Boolean(error)
      }),
      id: fieldValue,
      onBlur: onBlur,
      disabled: disabled
    });
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(TextFieldPhone));

/***/ }),

/***/ 80367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DO": function() { return /* binding */ TextFieldWrapper; },
/* harmony export */   "Nl": function() { return /* binding */ TextFieldInput; },
/* harmony export */   "ns": function() { return /* binding */ TextFieldError; },
/* harmony export */   "pU": function() { return /* binding */ TextFieldLabel; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68777);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96861);
/* harmony import */ var styles_breakpoints__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20881);
/* harmony import */ var _typography_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92680);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











function TextField(_ref) {
  var type = _ref.type,
      label = _ref.label,
      name = _ref.name,
      register = _ref.register,
      error = _ref.error,
      placeholder = _ref.placeholder,
      initialValue = _ref.initialValue;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(TextFieldWrapper, {
    "data-testid": "text-main-wrapper",
    children: [label && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(TextFieldLabel, {
      "data-testid": "text-field-label",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("label", {
        htmlFor: name,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          type: "mode2",
          fw: "light",
          children: label
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(TextFieldInput, {
      "data-testid": "text-field-wrapper",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("input", _objectSpread(_objectSpread({
        defaultValue: initialValue,
        type: type,
        id: name,
        "data-testid": "text-field",
        placeholder: placeholder
      }, register(name)), {}, {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()({
          invalid: Boolean(error)
        })
      }))
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(TextFieldError, {
      "data-testid": "text-field-error",
      children: (error === null || error === void 0 ? void 0 : error.message) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        type: "mode2",
        fw: "medium",
        children: error.message
      })
    })]
  });
}

var TextFieldWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "text-field__TextFieldWrapper",
  componentId: "sc-3wp9eq-0"
})(["&:not(:first-child){margin-top:24px;}@media ", "{&:not(:first-child){margin-top:20px;}}", ""], styles_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .device.tablet */ .U.tablet, function (_ref2) {
  var inputVariant = _ref2.inputVariant;
  return (0,lodash__WEBPACK_IMPORTED_MODULE_2__.isEqual)(inputVariant, 'underlined') && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(["display:flex;"]);
});
var TextFieldLabel = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "text-field__TextFieldLabel",
  componentId: "sc-3wp9eq-1"
})(["display:flex;margin-bottom:8px;", " ", " > label{cursor:pointer;> p{color:", ";", "}}", ""], function (_ref3) {
  var inputVariant = _ref3.inputVariant;
  return (0,lodash__WEBPACK_IMPORTED_MODULE_2__.isEqual)(inputVariant, 'underlined') && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(["color:", ";margin-bottom:0;align-items:end;& > label > p{font-size:20px;font-weight:500;line-height:1 !important;@media ", "{font-size:17px !important;}}"], function (_ref4) {
    var theme = _ref4.theme;
    return theme.colors.grayPallet9;
  }, styles_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .device.tablet */ .U.tablet);
}, function (_ref5) {
  var inputVariant = _ref5.inputVariant,
      disabled = _ref5.disabled;
  return (0,lodash__WEBPACK_IMPORTED_MODULE_2__.isEqual)(inputVariant, 'underlined') && disabled && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(["> label{cursor:not-allowed;> p{color:", " !important;}}"], function (_ref6) {
    var theme = _ref6.theme;
    return theme.colors.grayPallet18;
  });
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.blackPallet6;
}, function (_ref8) {
  var alignLeft = _ref8.alignLeft;
  return alignLeft ? 'text-align: left' : '';
}, function (_ref9) {
  var disabled = _ref9.disabled;
  return disabled && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(["> label{cursor:not-allowed;> p{color:", ";}}"], function (_ref10) {
    var theme = _ref10.theme;
    return theme.colors.grayPallet18;
  });
});
var TextFieldInput = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "text-field__TextFieldInput",
  componentId: "sc-3wp9eq-2"
})(["> input{height:55px;width:100%;border:1px solid ", ";background-color:", ";padding:16px 20px;font-weight:", ";color:", ";font-size:17px;line-height:23px;transition:200ms all ease;@media ", "{font-size:16px;}&::placeholder{color:", ";}&:hover{border-color:hsl(0,0%,70%);}&:focus{border:1px solid ", ";}&.invalid{border:1px solid ", ";}&:disabled,&:disabled:hover{border:1px solid ", ";color:", ";background-color:", ";}}", " ", " ", "{margin-top:5px;display:inline-block;text-align:left;}"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.grayPallet19;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.whitePallet3;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.typography.fontWeights.regular;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.blackPallet6;
}, styles_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .device.tablet */ .U.tablet, function (_ref15) {
  var theme = _ref15.theme;
  return theme.colors.grayPallet18;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.colors.green;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors.redPallet3;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.colors.grayPallet20;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.colors.grayPallet30;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.colors.grayPallet20;
}, function (_ref21) {
  var isTransparentBackground = _ref21.isTransparentBackground;
  return isTransparentBackground && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(["> input{background-color:transparent;}"]);
}, function (_ref22) {
  var inputVariant = _ref22.inputVariant;
  return (0,lodash__WEBPACK_IMPORTED_MODULE_2__.isEqual)(inputVariant, 'underlined') && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(["& > input{height:auto;border:none;border-bottom:1px solid ", ";background-color:transparent;padding:0 10px;margin-left:7px;@media ", "{padding:0 5px;}&:hover{border:none;border-bottom:1px solid ", ";}&:focus{border:none;border-bottom:1px solid ", ";}&.invalid{border:none;border-bottom:1px solid ", ";}&:disabled,&:disabled:hover{border:none;border-bottom:1px solid ", ";color:", ";background-color:transparent;}}"], function (_ref23) {
    var theme = _ref23.theme;
    return theme.colors.black;
  }, styles_breakpoints__WEBPACK_IMPORTED_MODULE_5__/* .device.tablet */ .U.tablet, function (_ref24) {
    var theme = _ref24.theme;
    return theme.colors.black;
  }, function (_ref25) {
    var theme = _ref25.theme;
    return theme.colors.green;
  }, function (_ref26) {
    var theme = _ref26.theme;
    return theme.colors.redPallet3;
  }, function (_ref27) {
    var theme = _ref27.theme;
    return theme.colors.grayPallet18;
  }, function (_ref28) {
    var theme = _ref28.theme;
    return theme.colors.grayPallet18;
  });
}, _typography_styles__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Typography */ .Z.Typography);
var TextFieldError = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "text-field__TextFieldError",
  componentId: "sc-3wp9eq-3"
})(["> p{color:", ";}& > span{font-size:12px;color:", ";}"], function (_ref29) {
  var theme = _ref29.theme;
  return theme.colors.red;
}, function (_ref30) {
  var theme = _ref30.theme;
  return theme.colors.red;
});
/* harmony default export */ __webpack_exports__["ZP"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(TextField));

/***/ }),

/***/ 96861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68777);

var Text = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "text__Text",
  componentId: "sc-1bgtwf9-0"
})(["text-transform:", ";text-decoration:", ";color:", ";", " ", ""], function (props) {
  return props.textTransform;
}, function (props) {
  return props.textDecoration;
}, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.blackPallet1;
}, function (_ref2) {
  var fw = _ref2.fw;

  switch (fw) {
    case 'light':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-family:Walsheim-Light;"]);

    case 'medium':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-family:Walsheim-Medium;"]);

    case 'bold':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-family:Walsheim-Bold;"]);

    default:
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-family:Walsheim-Regular;"]);
  }
}, function (props) {
  switch (props.type) {
    case 'mode1':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts.mode1.fontSize, props.theme.typography.texts.mode1.lineHeight);

    case 'mode2':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts.mode2.fontSize, props.theme.typography.texts.mode2.lineHeight);

    case 'mode3':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts.mode3.fontSize, props.theme.typography.texts.mode3.lineHeight);

    case 'mode4':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts.mode4.fontSize, props.theme.typography.texts.mode4.lineHeight);

    case 'mode5':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts.mode5.fontSize, props.theme.typography.texts.mode5.lineHeight);

    case 'mode6':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts.mode6.fontSize, props.theme.typography.texts.mode6.lineHeight);

    case 'mode7':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts.mode7.fontSize, props.theme.typography.texts.mode7.lineHeight);

    case 'mode8':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts.mode8.fontSize, props.theme.typography.texts.mode8.lineHeight);

    case 'mode9':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts.mode9.fontSize, props.theme.typography.texts.mode9.lineHeight);

    case 'mode10':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts.mode10.fontSize, props.theme.typography.texts.mode10.lineHeight);

    case 'mode11':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts.mode11.fontSize, props.theme.typography.texts.mode11.lineHeight);

    default:
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts["default"].fontSize, props.theme.typography.texts["default"].lineHeight);
  }
});
/* harmony default export */ __webpack_exports__["Z"] = (Text);

/***/ }),

/***/ 97652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ useGooglePlace; },
/* harmony export */   "c": function() { return /* binding */ getAddressObj; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50029);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_places_autocomplete__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48837);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var getAddressObj = /*#__PURE__*/function () {
  var _ref = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(address) {
    var results, storableLocation, ac, component;
    return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0,react_places_autocomplete__WEBPACK_IMPORTED_MODULE_3__/* .geocodeByAddress */ .NU)(address);

          case 2:
            results = _context.sent;
            storableLocation = {};

            for (ac = 0; ac < results[0].address_components.length; ac += 1) {
              component = results[0].address_components[ac];

              if (component.types.includes('sublocality') || component.types.includes('locality')) {
                storableLocation.city = component.long_name;
              } else if (component.types.includes('administrative_area_level_1')) {
                storableLocation.state = component.long_name;
              } else if (component.types.includes('postal_code')) {
                storableLocation.zip = component.long_name;
              } else if (component.types.includes('street_number')) {
                storableLocation.street1 = component.long_name === undefined ? '' : component.long_name;
              } else if (component.types.includes('route')) {
                if (storableLocation.street1 !== undefined) {
                  storableLocation.street1 += " ".concat(component.long_name);
                } else {
                  storableLocation.street1 = component.long_name;
                }
              } else if (component.types.includes('neighborhood')) {
                storableLocation.street2 = component.long_name;
              } else if (component.types.includes('administrative_area_level_2')) {
                storableLocation.county = component.long_name;
              }
            } // const latLng = await getLatLng(results[0]);


            return _context.abrupt("return", storableLocation);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getAddressObj(_x) {
    return _ref.apply(this, arguments);
  };
}();
var useGooglePlace = function useGooglePlace() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''),
      input = _useState[0],
      setInput = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(),
      googleData = _useState2[0],
      setGoogleData = _useState2[1];

  var selOptions = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)({
    componentRestrictions: {
      country: ['us']
    },
    location: new window.google.maps.LatLng(25.761681, -80.191788),
    types: ['address'],
    radius: 100000
  });
  var buyOptions = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)({
    componentRestrictions: {
      country: ['us']
    },
    location: new window.google.maps.LatLng(25.761681, -80.191788),
    radius: '10'
  });
  var hanldeChange = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function (address) {
    setInput(address);
  }, []);
  var hanldeSelect = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee2(address, placeID) {
      var obj;
      return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!placeID) {
                _context2.next = 6;
                break;
              }

              setInput(address);
              _context2.next = 4;
              return getAddressObj(address);

            case 4:
              obj = _context2.sent;
              setGoogleData(_objectSpread(_objectSpread({}, obj), {}, {
                full: address
              }));

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }(), []);
  return {
    selOptions: selOptions,
    buyOptions: buyOptions,
    input: input,
    googleData: googleData,
    hanldeChange: hanldeChange,
    hanldeSelect: hanldeSelect,
    setGoogleData: setGoogleData
  };
};

/***/ }),

/***/ 87023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Rw": function() { return /* binding */ createPasswordSchema; },
  "Hj": function() { return /* binding */ forgotSchema; },
  "iK": function() { return /* binding */ homeValuationSchema; },
  "Ci": function() { return /* binding */ listPriceSchema; },
  "pJ": function() { return /* binding */ listingPriceSchema; },
  "EX": function() { return /* binding */ listingPropertyDetailsSchema; },
  "PM": function() { return /* binding */ listingPropertyTypeSchema; },
  "Tb": function() { return /* binding */ listingSchema; },
  "wL": function() { return /* binding */ signInSchema; },
  "JJ": function() { return /* binding */ signUpSchema; },
  "aF": function() { return /* binding */ signUpWithGoogleSchema; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
;// CONCATENATED MODULE: ./utils/regex.ts
var EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,4}))$/;
var PASSWORD_REGEX = /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[~`!@#$%^&*()--+=§±]){1,})(?!.*\s).{8,}$/;
var ONLY_TEXT = /^[A-Za-z]*$/;
var TEXT_WITH_SPACES = /^[A-Za-z ]*$/;
;// CONCATENATED MODULE: ./utils/validations.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



 // @TODO: Replace the `This field is Required` occurences with the below const.

var requiredFieldErrorMessage = 'This field is Required';
var inalidValueErrorMessage = 'Invalid value';
var signInSchema = es/* object */.Ry().shape({
  signInEmail: es/* string */.Z_().matches(EMAIL_REGEX, 'Invalid Email address').required('This field is Required'),
  signInPassword: es/* string */.Z_().min(8, 'Password is too short - should be 8 chars minimum.').required('This field is Required')
}).required();
var signUpSchema = es/* object */.Ry().shape({
  signUpEmail: es/* string */.Z_().matches(EMAIL_REGEX, 'Invalid Email address').required('This field is Required'),
  signUpFirstName: es/* string */.Z_().matches(ONLY_TEXT, 'Invalid First Name').required('This field is Required'),
  signUpLastName: es/* string */.Z_().matches(ONLY_TEXT, 'Invalid Last Name').required('This field is Required'),
  signUpPhone: es/* string */.Z_().min(10, 'Invalid Phone number').required('This field is Required'),
  signUpPassword: es/* string */.Z_().matches(PASSWORD_REGEX, "Password must contain at least one special characters e.g. '-','+', one digit, and one letter, and should be 8 characters minimum.").required('This field is Required'),
  signUpUsagePurpose: es/* string */.Z_().required('This field is Required')
}).required();
var signUpWithGoogleSchema = es/* object */.Ry().shape({
  signUpGoogleUsagePurpose: es/* string */.Z_().required('This field is Required'),
  signUpGooglePhone: es/* string */.Z_().required('This field is Required')
}).required();
var listPriceSchema = es/* object */.Ry().shape({
  listPrice: es/* string */.Z_().required('This field is Required'),
  agentCommission: es/* string */.Z_().required('This field is Required')
}).required();
var forgotSchema = es/* object */.Ry().shape({
  forgotEmail: es/* string */.Z_().matches(EMAIL_REGEX, 'Invalid Email address').required('This field is Required')
}).required();
var createPasswordSchema = es/* object */.Ry().shape({
  createPassword: es/* string */.Z_().matches(PASSWORD_REGEX, "Password must contain at least one special characters e.g. '-','+', one digit, and one letter, and should be 8 characters minimum.").required('This field is Required'),
  createPasswordConfirm: es/* string */.Z_().oneOf([es/* ref */.iH('createPassword'), null], 'Passwords must match')
}).required();
var leadSchemaShape = {
  address: es/* string */.Z_().required(requiredFieldErrorMessage),
  email: es/* string */.Z_().matches(EMAIL_REGEX, 'Invalid Email').required(requiredFieldErrorMessage),
  phone_number: es/* string */.Z_().min(10, 'Invalid Phone number').required(requiredFieldErrorMessage)
};
var listingSchema = es/* object */.Ry().shape(_objectSpread(_objectSpread({}, leadSchemaShape), {}, {
  name: es/* string */.Z_().matches(TEXT_WITH_SPACES, 'Invalid Name').required(requiredFieldErrorMessage),
  is_open_to_buy: es/* string */.Z_().nullable().matches(ONLY_TEXT, 'Invalid Value').required(requiredFieldErrorMessage)
})).required();
var homeValuationSchema = es/* object */.Ry().shape(_objectSpread(_objectSpread({}, leadSchemaShape), {}, {
  first_name: es/* string */.Z_().matches(ONLY_TEXT, 'Invalid First Name').required(requiredFieldErrorMessage),
  last_name: es/* string */.Z_().matches(ONLY_TEXT, 'Invalid Last Name').required(requiredFieldErrorMessage)
})).required();
var listingPropertyTypeSchema = es/* object */.Ry().shape({
  property_type: es/* string */.Z_().required(requiredFieldErrorMessage),
  is_waterfront_property: es/* string */.Z_().nullable().matches(ONLY_TEXT, 'Invalid Value').required(requiredFieldErrorMessage),
  has_swimming_pool: es/* string */.Z_().nullable().matches(ONLY_TEXT, 'Invalid Value').required(requiredFieldErrorMessage)
}).required();
var listingPropertyDetailsSchema = es/* object */.Ry().shape({
  bed_count: es/* number */.Rx().required(requiredFieldErrorMessage).min(0, inalidValueErrorMessage).transform(function (_, val) {
    return val ? Number(val) : null;
  }).nullable(),
  bath_count: es/* number */.Rx().required(requiredFieldErrorMessage).min(0, inalidValueErrorMessage).nullable().transform(function (_, val) {
    return val ? Number(val) : null;
  }),
  home_area: es/* number */.Rx().required(requiredFieldErrorMessage).min(0, inalidValueErrorMessage).nullable().transform(function (_, val) {
    return val ? Number(val) : null;
  })
}).required(); // @TODO: Check edge cases for validations

var listingPriceSchema = es/* object */.Ry().shape({
  desired_price: es/* number */.Rx().required(requiredFieldErrorMessage).min(1, inalidValueErrorMessage).nullable().transform(function (_, val) {
    return val ? Number(val) : null;
  }),
  buyer_agent_commission: es/* number */.Rx().min(0, 'Please enter a number from 0 to 3.').max(3, 'Please enter a number from 0 to 3.').nullable().transform(function (_, val) {
    return (0,lodash.isNaN)(val) ? null : Number(val);
  }),
  home_valuation_price: es/* number */.Rx().min(0, inalidValueErrorMessage).nullable()
}).required();

/***/ })

}]);